import RoutesMap from '../../route_control/RouteControl'
import { StudentExamList, StudentExamInstructions, StudentExamStart, StudentExamDetails } from '../../pages/student_exam'

export const StudentExamRouteImport = { RoutesMap, StudentExamList, StudentExamInstructions, StudentExamStart, StudentExamDetails }
